<template>
  <div class="min-h-screen bg-white">
    <!--  -->
    <div class="max-w-7xl mx-auto px-3 sm:px-4 lg:px-4">
      <!-- 头部区域 -->
      <div class="pt-6 sm:pt-8 lg:pt-12 pb-4 sm:pb-6 lg:pb-8">
        <h1 class="text-xl sm:text-2xl lg:text-4xl font-bold mb-2 sm:mb-3 lg:mb-4 text-green-800 italic text-center lg:text-left leading-tight">
          {{ t('globalSupply.title1') }}
        </h1>
        <p class="text-gray-600 text-sm sm:text-base lg:text-lg text-center lg:text-left leading-relaxed">
          {{ t('globalSupply.subtitle1') }}
        </p>
      </div>

      <!-- 地图区域 -->
      <div class="flex flex-col lg:flex-row gap-4 sm:gap-6 lg:gap-8 mb-8 sm:mb-12 lg:mb-16">
        <div class="flex-1 order-2 lg:order-1">
          <div class="w-full h-[200px] sm:h-[250px] lg:h-[400px] rounded-lg overflow-hidden shadow-sm">
            <img :src="ditu" class="w-full h-full object-cover" />
          </div>
        </div>
        <div class="w-full lg:w-[340px] order-1 lg:order-2">
          <div class="bg-white rounded-lg p-3 sm:p-4 lg:p-6 shadow-sm border border-gray-100">
            <h3 class="text-base sm:text-lg lg:text-xl font-bold mb-1 sm:mb-2 text-gray-800 text-center lg:text-left">
              {{ t('globalSupply.title2') }}
            </h3>
            <p class="text-xs sm:text-sm lg:text-sm text-gray-500 mb-3 sm:mb-4 lg:mb-6 text-center lg:text-left leading-relaxed">
              {{ t('globalSupply.subtitle2') }}
            </p>
            <div class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 sm:gap-4 lg:gap-6">
              <div
                v-for="(country, index) in countries"
                :key="index"
                class="flex flex-col items-center p-1.5 sm:p-2 rounded-lg hover:bg-gray-50 transition-colors duration-200 active:bg-gray-100"
              >
                <div class="w-8 h-6 sm:w-10 sm:h-7 lg:w-12 lg:h-8 mb-1 sm:mb-2 rounded overflow-hidden shadow-sm">
                  <img
                    :src="country.flag"
                    :alt="t(`globalSupply.countries.${country.key}`)"
                    class="w-full h-full object-cover"
                  />
                </div>
                <span class="text-xs sm:text-xs lg:text-xs text-gray-700 font-medium text-center leading-tight px-1">{{  
                  t(`globalSupply.countries.${country.key}`)
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 应用场景区域 -->
    <div class="bg-[#2f5c45] py-8 sm:py-12 lg:py-20">
      <div class="max-w-7xl mx-auto px-3 sm:px-4 lg:px-0">
        <h2 class="text-lg sm:text-xl lg:text-2xl font-bold mb-4 sm:mb-6 lg:mb-8 text-white text-center lg:text-left leading-tight">
          {{ t('globalSupply.applicationScenario.title') }}
        </h2>
        <p class="text-white/90 mb-4 sm:mb-6 lg:mb-8 whitespace-pre-line text-xs sm:text-sm lg:text-base text-center lg:text-left leading-relaxed px-2 sm:px-0">
          {{ t('globalSupply.applicationScenario.subtitle') }}
        </p>

        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
          <div
            v-for="(scene, index) in scenes"
            :key="index"
            class="overflow-hidden rounded-lg group"
          >
            <div class="relative h-40 sm:h-48 lg:h-64 overflow-hidden rounded-lg">
              <img
                :src="scene.image"
                :alt="
                  t(`globalSupply.applicationScenario.scenes.${index}.title`)
                "
                class="w-full h-full object-cover object-top rounded-lg transition-transform duration-300 group-hover:scale-105 group-active:scale-105"
              />
            </div>
            <div class="text-center mt-2 sm:mt-3 lg:mt-4">
              <h3 class="text-sm sm:text-base lg:text-lg text-white/90 font-semibold mb-2 leading-tight px-2">
                {{
                  t(`globalSupply.applicationScenario.scenes.${index}.title`)
                }}
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { ref, onMounted, watch, onUnmounted } from 'vue'
  import { useI18n } from 'vue-i18n'
  import * as echarts from 'echarts'
  import { registerMap } from 'echarts/core'
  import ditu from '../../../assets/525565/ditu.jpg'
  import japan from '../../../assets/country/日本.jpg'
  import australia from '../../../assets/country/澳大利亚.jpg'
  import brazil from '../../../assets/country/巴西.jpg'
  import germany from '../../../assets/country/德国.jpg'
  import france from '../../../assets/country/法国.jpg'
  import netherlands from '../../../assets/country/荷兰.jpg'
  import canada from '../../../assets/country/加拿大.jpg'
  import america from '../../../assets/country/美国.jpg'
  import saudiArabia from '../../../assets/country/沙特.jpg'
  import spain from '../../../assets/country/西班牙.jpg'
  import newZealand from '../../../assets/country/新西兰.jpg'
  import britain from '../../../assets/country/英国.jpg'
  import app1 from '../../../assets/apptionxxx/1.jpg'
  import app2 from '../../../assets/apptionxxx/2.jpg'
  import app3 from '../../../assets/apptionxxx/3.jpg'


  const { t, locale } = useI18n()

  const chartRef = ref(null)
  let chart = null

  // 国家列表配置
  const countries = [
    {
      key: 'britain',
      flag: britain
    },
    {
      key: 'germany',
      flag: germany
    },
    {
      key: 'netherlands',
      flag: netherlands
    },
    {
      key: 'spain',
      flag: spain
    },
    {
      key: 'france',
      flag: france
    },
    {
      key: 'australia',
      flag: australia
    },
    {
      key: 'america',
      flag: america
    },
    {
      key: 'canada',
      flag: canada
    },
    {
      key: 'newZealand',
      flag: newZealand
    },
    {
      key: 'brazil',
      flag: brazil
    },
    {
      key: 'japan',
      flag: japan
    },
    {
      key: 'saudiArabia',
      flag: saudiArabia
    }
  ]

  // 应用场景配置
  const scenes = [
    {
      image: app1
    },
    {
      image: app2
    },
    {
      image: app3
    }
  ]

  // 初始化地图
  const initMap = async () => {
    try {
      const response = await fetch('/world.json')
      const worldJson = await response.json()
      registerMap('world', worldJson)

      if (chartRef.value) {
        // 如果图表已存在，先销毁
        if (chart) {
          chart.dispose()
        }

        // 重新初始化图表
        chart = echarts.init(chartRef.value)

        const option = {
          animation: false,
          backgroundColor: '#ffffff',
          geo: {
            map: 'world',
            roam: false,
            selectedMode: false,
            label: {
              show: false
            },
            itemStyle: {
              areaColor: '#5a9d7a',
              borderColor: '#fff',
              borderWidth: 1
            },
            emphasis: {
              disabled: true
            }
          },
          series: [
            {
              type: 'lines',
              coordinateSystem: 'geo',
              data: [
                // 中国到北美洲 - 调整终点到北美中心
                {
                  coords: [
                    [116.4, 39.9],
                    [-95, 50]
                  ],
                  lineStyle: { color: '#FFD700', width: 2 }
                },
                // 中国到欧洲 - 调整到欧洲中心
                {
                  coords: [
                    [116.4, 39.9],
                    [15, 50]
                  ],
                  lineStyle: { color: '#FFD700', width: 2 }
                },
                // 中国到非洲 - 调整到非洲中心
                {
                  coords: [
                    [116.4, 39.9],
                    [15, -5]
                  ],
                  lineStyle: { color: '#FFD700', width: 2 }
                },
                // 中国到南美洲 - 调整到南美中心
                {
                  coords: [
                    [116.4, 39.9],
                    [-55, -15]
                  ],
                  lineStyle: { color: '#FFD700', width: 2 }
                },
                // 中国到澳大利亚 - 调整到澳洲中心
                {
                  coords: [
                    [116.4, 39.9],
                    [135, -25]
                  ],
                  lineStyle: { color: '#FFD700', width: 2 }
                },
                // 中国到亚洲其他地区 - 调整到东南亚
                {
                  coords: [
                    [116.4, 39.9],
                    [105, 10]
                  ],
                  lineStyle: { color: '#FFD700', width: 2 }
                }
              ],
              effect: {
                show: false
              },
              lineStyle: {
                width: 2,
                opacity: 0.8,
                curveness: 0.2
              }
            },
            // 修正地区标签位置
            {
              type: 'scatter',
              coordinateSystem: 'geo',
              symbol: 'circle',
              symbolSize: 0,
              label: {
                show: true,
                formatter: '{b}',
                position: 'top',
                color: '#FFD700',
                fontSize: 10,
                fontWeight: 'bold',
                backgroundColor: 'rgba(0,0,0,0.5)',
                padding: [4, 8],
                borderRadius: 4
              },
              data: [
                // 修正标签位置，确保地理准确性
                {
                  name: t('globalSupply.regions.withinChina'),
                  value: [116.4, 39.9]
                },
                { name: t('globalSupply.regions.asia'), value: [105, 10] },
                { name: t('globalSupply.regions.europe'), value: [15, 50] },
                {
                  name: t('globalSupply.regions.northAmerica'),
                  value: [-95, 50]
                },
                {
                  name: t('globalSupply.regions.southAmerica'),
                  value: [-55, -15]
                },
                { name: t('globalSupply.regions.africa'), value: [15, -5] },
                { name: t('globalSupply.regions.australia'), value: [135, -25] }
              ]
            }
          ]
        }
        chart.setOption(option)
      }
    } catch (error) {
      console.error('加载世界地图数据失败:', error)
    }
  }

  // 监听语言变化，重新初始化地图
  watch(locale, () => {
    // 延迟执行，确保翻译已更新
    setTimeout(() => {
      initMap()
    }, 100)
  })

  // 组件挂载后初始化地图
  onMounted(() => {
    initMap()
  })

  // 组件卸载时销毁图表
  onUnmounted(() => {
    if (chart) {
      chart.dispose()
      chart = null
    }
  })
</script>

<style scoped>
  .echarts-tooltip {
    background: rgba(255, 255, 255, 0.9) !important;
    padding: 10px !important;
    border-radius: 4px !important;
    border: 1px solid #eee !important;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1) !important;
  }
</style>
